import { useEffect, useMemo,useState } from "react";
import {useIntl} from "react-intl";
import { useMediaQuery } from "react-responsive";

import QuestionsListAssetTreeSummary from "@/components/atom/QuestionsListAssetTreeSummary/QuestionsListAssetTreeSummary";
import QuestionsListItems from "@/components/atom/QuestionsListItems/QuestionsListItems";
import { THandleSendParams } from "@/components/pages/ChatPage/types";
import { useAppDispatch, useAppSelector } from "@/configuration/setup/hooks";
import {
    addQuestions,
    selectAllFAQs
} from "@/store/faq/faqSlice";
import { TFAQsItem } from "@/store/faq/types";
import { getFaqIconStats, getMappedFaqs } from "@/store/faq/utils";
import {setIsSearching} from "@/store/search/searchSlice";
import { closeSidebar } from "@/store/sidebar/sidebarSlice";
import {
    selectActiveThread,
    selectIsThreadLoading
} from "@/store/thread/threadSlice";

type ExampleQuestionsFilterListProps = {
    isLoading?: boolean;
    isOnboarding: boolean;
    handleSend?: (params: THandleSendParams) => Promise<void>;
};


const ExampleQuestionsFilterList = ({isLoading, isOnboarding, handleSend} : ExampleQuestionsFilterListProps) => {
    const dispatch = useAppDispatch();

    const activeThread = useAppSelector(selectActiveThread);
    const isThreadsLoading = useAppSelector(selectIsThreadLoading(activeThread?.threadId || null));
    const allFAQs = useAppSelector(selectAllFAQs);

    const intl = useIntl();
    const mappedFAQs = useMemo(() => getMappedFaqs(intl), []);
    const faqIcons = getFaqIconStats(mappedFAQs);


    useEffect(() => {
        dispatch(addQuestions(mappedFAQs));
    }, [mappedFAQs])   

    const isSmallScreen = useMediaQuery({ query: "(max-width: 47.5rem)" });


    const [searchValue, setSearchValue] = useState("");
    const [filterFaqsList, setFilterFaqsList] = useState<string | null>(null);
    const [faqsList, setFaqsList] = useState<TFAQsItem[]>([]);

    const filterFaqs = () => {
        return allFAQs.filter(item =>
            item.name.toLowerCase().includes(searchValue.toLowerCase()) &&
            (filterFaqsList ? item.icon === filterFaqsList : true)
        );
    };

    useEffect(() => {
        setFaqsList(filterFaqs());
    }, [allFAQs, searchValue, filterFaqsList]);

    const handleSelection = async (item: TFAQsItem) => {
        if (isOnboarding && handleSend) {
            await handleSend({
                content: item.name,
                isOnboarding,
                nextStepIndex: 'step-0',
            });
        }

        const question = mappedFAQs.find(q => q.id === item.id);

        if (isLoading || isThreadsLoading || !question) return;

        if (handleSend) {
            await handleSend({
                content: question.name,
                isOnboarding: false,
            });
            dispatch(setIsSearching(false))
        }

        if (isSmallScreen) {
            dispatch(closeSidebar());
        }
    };

    return (
        <>
            {!isThreadsLoading && (
                <>
                    <QuestionsListAssetTreeSummary
                        isOnboarding={isOnboarding}
                        faqIcons={faqIcons}
                        activeIcon={filterFaqsList}
                        onFilterSelect={setFilterFaqsList}
                        onSearch={setSearchValue}
                    />
                    <QuestionsListItems
                        isOnboarding={isOnboarding}
                        faqsList={faqsList}
                        searchValue={searchValue}
                        handleSelection={handleSelection}
                    />
                </>
            )}
        </>
    );
};

export default ExampleQuestionsFilterList;
